import moment from 'moment';

/**
 * Converts UTC timestamp to local timezone and formats it
 * @param {string|Date} utcDate - UTC date string or Date object
 * @param {string} format - Moment format string (default: 'MM-DD-YYYY')
 * @returns {string} Formatted date in local timezone
 */
export function formatDateLocal(utcDate, format = 'MM-DD-YYYY') {
  if (!utcDate || utcDate === '0000-00-00' || utcDate === '0000-00-00 00:00:00' || utcDate === null) {
    return 'N/A';
  }
  
  // Parse as UTC and convert to local timezone
  // moment.utc() parses the date as UTC, then .local() converts to browser's local timezone
  return moment.utc(utcDate).format(format);
}

/**
 * Formats date with time in local timezone
 * @param {string|Date} utcDate - UTC date string or Date object
 * @param {string} format - Moment format string (default: 'MM-DD-YYYY HH:mm')
 * @returns {string} Formatted date/time in local timezone
 */
export function formatDateTimeLocal(utcDate, format = 'MM-DD-YYYY HH:mm') {
  if (!utcDate || utcDate === '0000-00-00' || utcDate === '0000-00-00 00:00:00' || utcDate === null) {
    return 'N/A';
  }
  
  return moment.utc(utcDate).local().format(format);
}

/**
 * Formats date only (no time) in local timezone
 * @param {string|Date} utcDate - UTC date string or Date object
 * @returns {string} Formatted date in MM-DD-YYYY format
 */
export function formatDateOnlyLocal(utcDate) {
  return formatDateLocal(utcDate, 'MM-DD-YYYY');
}
